import "./Projects.module.css";
import Header from "@/reusable_sections/Header";
import ProjectsHero from "./sections/ProjectsHero";
import ProjectListings from "./sections/ProjectListings";
import ProjectsCallToAction from "./sections/ProjectsCallToAction";
import Footer from "@/reusable_sections/Footer";
export default function ProjectsPage() {
  return <div>
      <Header />
      <ProjectsHero />
      <ProjectListings />
      <ProjectsCallToAction />
      <Footer />
    </div>;
}